import RBush from "rbush";
export class GeoRBush extends RBush {
    compareMinX(a, b) {
        return a.lat - b.lat;
    }
    compareMinY(a, b) {
        return a.lon - b.lon;
    }
    toBBox(item) {
        return { minX: item.lat, minY: item.lon, maxX: item.lat, maxY: item.lon };
    }
}
//# sourceMappingURL=GeoRBush.js.map